<template>
  <div class="account-container">
    <el-form ref="eaParams" :model="eaParams" :rules="eaRules" label-position="top" label-width="180px">
      <el-form-item>
        <el-input
          type="textarea"
          :rows="2"
          class="form-item-width"
          style="width: 300px"
          placeholder="请输入待解析内容案例：gucci上海恒隆/古驰上海恒隆"
          @input="explain"
          v-model="input_content">
        </el-input>
      </el-form-item>
      <el-form-item v-if="eaParams.reim_no" label="编号：" prop="code">
        <el-input v-model="eaParams.reim_no" type="text" class="form-item-width" />
      </el-form-item>
      <el-form-item label="是否完工：" prop="is_completed" v-if="eaParams.pre_quote_status != 1">
        <el-radio-group v-model="eaParams.is_completed" class="form-item-width" @change="onIsCompletedChange">
          <el-radio :label="0">否</el-radio>
          <el-radio :label="1">是</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item v-if="eaParams.is_completed === 1 && eaParams.pre_quote_status != 1" label="完工日期：" prop="finished_at">
        <el-date-picker v-model="eaParams.completed_at" style="width: 240px;" type="date" value-format="yyyy-MM-dd" placeholder="请选择" class="form-item-width" />
      </el-form-item>
      <el-form-item label="品牌：" prop="brand_id">
        <el-select v-model="eaParams.brand_id" placeholder="请选择" filterable clearable class="form-item-width" @change="syncShops">
          <el-option v-for="(v, k) in brandsList" :key="k" :value="v.id" :label="v.brand_en" />
        </el-select>
      </el-form-item>
      <el-form-item label="城市：" prop="brand_id">
        <el-select v-model="eaParams.city_id" placeholder="请选择" filterable clearable class="form-item-width" @change="syncData">
          <el-option v-for="(v, k) in cityList" :key="k" :value="v.id" :label="v.city_cn" />
        </el-select>
      </el-form-item>
      <el-form-item label="商场：" prop="market_id">
        <el-select v-model="eaParams.market_id" :allow-create="true" placeholder="支持输入" filterable class="form-item-width" @change="syncShops">
          <el-option v-for="(v, k) in markets" :key="k" :value="v.id" :label="v.market_cn" />
        </el-select>
      </el-form-item>
      <el-form-item label="店铺：" prop="store_id">
        <el-select v-model="eaParams.store_id" placeholder="请选择" filterable class="form-item-width" @change="changeStore">
          <el-option v-for="v in storeList" :key="v.id" :value="v.id" :label="v.name_cn" />
        </el-select>
      </el-form-item>
      <el-form-item label="公司：" prop="company_id">
        <el-select v-model="eaParams.company_id" placeholder="请选择" filterable class="form-item-width" @change="changeStore">
          <el-option v-for="v in companies" :key="v.id" :value="v.id" :label="v.company_en" />
        </el-select>
      </el-form-item>
      <el-form-item label="维修类型：" prop="ma_type_cn">
        <el-radio-group v-model="eaParams.ma_type_cn"  class="form-item-width" @change="changeRepairType">
          <el-radio label="定期维保" />
          <el-radio label="紧急维修" />
        </el-radio-group>
      </el-form-item>
      <el-form-item v-if="eaParams.ma_type_cn === '定期维保'" label="预约时间：" prop="appo_at">
        <el-date-picker
          v-model="eaParams.appo_at"
          type="date"
          value-format="yyyy-MM-dd"
          placeholder="选择日期"
        />
      </el-form-item>
      <el-form-item label="选择维修项目：" prop="ma_cate_id">
        <el-select v-model="eaParams.ma_cate_id" :allow-create="true" placeholder="支持输入" filterable clearable class="form-item-width" @change="syncShops">
          <el-option v-for="(v, k) in projects" :key="k" :value="v.id" :label="v.cn_name ? v.cn_name : v.en_name" />
        </el-select>
      </el-form-item>
      <el-form-item label="工作内容：" prop="ma_remark">
        <el-input v-model="eaParams.ma_remark" type="text" placeholder="0-60个字符" class="form-item-width" />
      </el-form-item>
      <!--<el-form-item label="报修区域：" prop="location">
        <el-input v-model="eaParams.location" type="text" placeholder="0-60个字符" class="form-item-width" />
      </el-form-item>
      <el-form-item label="报修图片：" prop="pictures">
        <el-upload
          class="upload-demo form-item-width"
          action="eric"
          :http-request="picturesUpload"
          :on-preview="handlePreview"
          :on-remove="handlePicturesRemove"
          :auto-upload="true"
          :multiple="true"
          :before-upload="beforeImgUpload"
          :file-list="eaParams.picture_images"
          list-type="picture-card"
        >
          <i class="el-icon-plus" />
        </el-upload>
      </el-form-item>-->
      <!--<el-form-item label="选择工人">
        <el-select
          v-model="eaParams.
          "
          multiple
          filterable
          remote
          reserve-keyword
          placeholder="请输入关键词"
          :remote-method="remoteMethod">
          <el-option
            v-for="item in personList"
            :key="item.worker_id"
            :label="item.worker"
            :value="item.worker_id">
          </el-option>
        </el-select>
      </el-form-item>-->

      <el-form-item label="明细：" prop="details">
        <el-table :data="eaParams.reim_detail_list" border stripe class="form-element">
          <el-table-column label="费用类别" prop="worker_name" align="center" width="130px">
            <template slot="header">
              <div>费用类别</div>
              <div style="color: red;">请谨慎选择</div>
            </template>
            <template slot-scope="scope">
              <el-select v-if="scope.row.detail !== '企业滴滴' && scope.row.detail !== '企业货拉拉'" v-model="scope.row.reim_type" placeholder="请选择" filterable @change="onReimTypeChange(scope.row)">
                <el-option v-for="v in feeType" :key="v.k" :value="v.v" :label="v.k" />
              </el-select>
              <el-input v-if="scope.row.detail === '企业滴滴'" type="text" readonly v-model="qy_di_di_reim_type_cn" />
              <el-input v-if="scope.row.detail === '企业货拉拉'" type="text" readonly v-model="qy_huo_la_la_reim_type_cn" />
            </template>
          </el-table-column>
          <el-table-column label="明细" prop="description" align="center" min-width="270px">
            <template slot="header">
              <span>明细</span><span style="color: red">*</span>
            </template>
            <template slot-scope="scope">
              <el-autocomplete
                class="inline-input"
                v-if="scope.row.detail !== '企业滴滴'"
                v-model="scope.row.detail"
                :fetch-suggestions="querySearch"
                placeholder="请输入内容"
                @select="handleSelect"
              ></el-autocomplete>
              <el-input v-if="scope.row.detail === '企业滴滴'" v-model="scope.row.detail" type="text" readonly />
              <!--<el-input v-model="scope.row.detail" type="textarea" autosize @input="onDetailChange('name',scope.row)" />-->
            </template>
          </el-table-column>
          <el-table-column label="数量" prop="qty" align="center" min-width="150px">
            <template slot="header">
              <span>数量</span><span style="color: red">*</span>
            </template>
            <template slot-scope="scope">
              <el-input v-model="scope.row.num" type="text" class="input-center" @input="onDetailChange('num', scope.row)">
                <template slot="append">
                  <el-select v-model="scope.row.unit" :disabled="scope.row.reim_type === 'labor_cost'" filterable allow-create placeholder="单位" class="unit-select" popper-class="aaa" style="width: 80px">
                    <el-option v-for="(item, k) in qyts" :key="k" :value="item.value" :label="item.value" />
                  </el-select>
                </template>
              </el-input>
            </template>
          </el-table-column>
          <el-table-column label="单价" prop="unit_price" align="center" min-width="100px">
            <template slot="header">
              <span>单价</span><span style="color: red">*</span>
            </template>
            <template slot-scope="scope">
              <el-input v-model="scope.row.price" type="text" class="input-right" @input="onDetailChange('price',scope.row)" />
            </template>
          </el-table-column>
          <el-table-column label="小计" prop="subtotal" align="center" min-width="100px">
            <template slot="header">
              <span>小计</span>
            </template>
            <template slot-scope="scope">
              <el-input v-model="scope.row.total_price" type="text" />
            </template>
          </el-table-column>
          <el-table-column label="备注" prop="remark" align="center" min-width="270px">
            <template slot="header">
              <span>备注</span>
            </template>
            <template slot-scope="scope">
              <el-input v-if="scope.row.detail !== '企业滴滴' && scope.row.detail !== '企业货拉拉'" v-model="scope.row.remark" type="textarea" @input="onDetailChange('remark',scope.row)" />
              <div v-if="scope.row.detail === '企业滴滴'">
                <div v-for="(item, index) in car_date_list">
                  <div>
                    <span style="cursor: pointer" @click="changeSelectDate(item, index)">{{ item }}</span>
                    <i class="el-icon-delete" style="cursor: pointer" @click="deleteSelectDate(index)">删除</i>
                  </div>
                </div>
                <div>
                  <el-button @click="addDiDiTime">添加打车时间</el-button>
                </div>
              </div>
              <div v-if="scope.row.detail === '企业货拉拉'">
                <div v-for="(item, index) in car_la_la_date_list">
                  <div>
                    <span style="cursor: pointer" @click="changeSelectLaLaDate(item, index)">{{ item }}</span>
                    <i class="el-icon-delete" style="cursor: pointer" @click="deleteSelectLaLaDate(index)">删除</i>
                  </div>
                </div>
                <div>
                  <el-button @click="addLaLaTime">添加打车时间</el-button>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="合作工人" prop="worker_name" align="center" width="200px">
            <template slot="header">
              <span>合作工人</span>
            </template>
            <template slot-scope="scope">
              <el-select v-model="scope.row.worker_uid" placeholder="请选择" filterable @change="val => updateUser(val, scope.row.index)">
                <el-option v-for="v in workerList" :key="v.id" :value="v.worker_uid" :label="v.worker" />
              </el-select>
            </template>
          </el-table-column>
          
          <el-table-column label="" align="center" class="el-icon-delete" min-width="30px">
            <template slot-scope="scope">
              <span v-if="scope.row.index !== 0 && ['add', 'update'].indexOf(pageType) !== -1" @click="delDetailParam(scope.row)"><i class="el-icon-delete" /></span>
            </template>
          </el-table-column>
        </el-table>
        <el-button type="info" class="el-icon-circle-plus-outline form-item-width" @click="addDetailParam">添加新行</el-button>
      </el-form-item>
      <el-form-item label="合计金额：" prop="total_amount">
        <el-input v-model="eaParams.total_price" type="text" class="form-item-width" />
      </el-form-item>
      <el-form-item v-if="eaParams.is_completed === 1 && eaParams.pre_quote_status != 1" label="签收单：" prop="receipts">
        <el-upload
          class="upload-demo form-item-width"
          action="eric"
          :http-request="receiptsUpload"
          :on-preview="handlePreview"
          :on-remove="handleReceiptsRemove"
          :auto-upload="true"
          :multiple="true"
          :before-upload="beforeImgUpload"
          :file-list="eaParams.sign_images"
          list-type="picture-card"
        >
          <i class="el-icon-plus" />
        </el-upload>
      </el-form-item>
      <el-form-item label="发票或收据(可选)：" prop="invoices" v-if="eaParams.pre_quote_status != 1">
        <el-upload
          class="upload-demo form-item-width"
          action="eric"
          :http-request="invoicesUpload"
          :on-preview="handlePreview"
          :on-remove="handleInvoicesRemove"
          :auto-upload="true"
          :multiple="true"
          :before-upload="beforeImgUpload"
          :file-list="eaParams.bill_images"
          list-type="picture-card"
        >
          <i class="el-icon-plus" />
        </el-upload>
      </el-form-item>
      <el-form-item label="是否预支：" prop="is_advance" v-if="eaParams.pre_quote_status != 1 && !subordinateWorker">
        <el-radio-group v-model="eaParams.is_advance" class="form-item-width">
          <el-radio :label="0">否</el-radio>
          <el-radio :label="1">是</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="是否已在群里报备：" prop="is_report" v-if="eaParams.pre_quote_status != 1">
        <el-switch v-model="eaParams.is_report"
                   active-value="1"
                   inactive-value="0"
        />
      </el-form-item>
      <el-form-item label="是否预报价：" prop="pre_quote_status" v-if="eaParams.pre_quote_status != 1 && !subordinateWorker">
        <el-radio-group v-model="eaParams.pre_quote_status" class="form-item-width" @change="updateChange()">
          <el-radio :label="0">否</el-radio>
          <el-radio :label="1">是</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="是否同步报告：" prop="sync_report_status" v-if="user_id == 1 || user_id == 9">
        <el-radio-group v-model="eaParams.sync_report_status" class="form-item-width" @change="updateChange()">
          <el-radio :label="0">否</el-radio>
          <el-radio :label="1">是</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="备注(可选)：">
        <el-input v-model="eaParams.remark" type="textarea" placeholder="多条请换行" autosize :rows="5" class="form-item-width" />
      </el-form-item>
      <el-form-item label="">
        <el-button type="primary" @click="addEa('create')">提交</el-button>
        <el-button type="primary" @click="addEa('tmp_save')">暂存</el-button>
        <el-button type="info" @click="closeDialog">返回</el-button>
      </el-form-item>
    </el-form>
    <el-dialog :visible.sync="previewDialog" width="50%" align="center" :modal="false">
      <img width="100%" :src="previewUrl" alt="">
    </el-dialog>
    <el-dialog v-if="addDiDiDialog" title="选择打车时间" :visible.sync="addDiDiDialog" :append-to-body="true">
      <el-date-picker
        v-if="addDiDiDialog"
        v-model="chooseDate"
        type="datetime"
        value-format="yyyy-MM-dd HH:mm:ss"
        @change="selectDiDiDate"
        placeholder="选择日期时间">
      </el-date-picker>
    </el-dialog>

    <el-dialog v-if="addLaLaDialog" title="选择打车时间" :visible.sync="addLaLaDialog" :append-to-body="true">
      <el-date-picker
        v-if="addLaLaDialog"
        v-model="chooseLaLaDate"
        type="datetime"
        value-format="yyyy-MM-dd HH:mm:ss"
        @change="selectLaLaDate"
        placeholder="选择日期时间">
      </el-date-picker>
    </el-dialog>
  </div>
</template>

<script>
import {
  applyExpenseAccount,
  cancelApplyExpenseAccount,
  deleteDraftExpenseAccount,
} from '@/api/ea'
import {
  addStore,
  companies, getBrandList, getCityList,
  getImageOss, getMarketList, getOssToken, getShopList, parseAddress,
  qyts, searchWorkers
} from "../../../api/order";
import {createOrderAndReim, createRem} from "../../../api/reimbursement";
import OSS from "ali-oss";
import {getCategories} from "../../../api/reimbursement";
import {getCompanyList, getFileRealPath} from "../../../api/util";
import {getCooperateWorkerList} from "../../../api/user";

export default {
  components: {
  },
  props: {
    closeDialog: {
      type: Function,
      default: null
    },
    detailPageType: {},
    preQuoteStatus: {},
    detailData: {},
    subordinateWorker: {}
  },
  data() {
    const validateDetail = (rule, detail, callback) => {
      for (let i = 0; i < detail.length; i++) {
        if (detail.length > 1 && detail[i].name.length <= 0 && detail[i].num === '' && detail[i].price === '') {
          detail.splice(i, 1)
        } else {
          if (detail[i].name.length <= 0) {
            callback(new Error('请完善第' + (i + 1) + '行明细'))
          }
          if (detail[i].num <= 0) {
            callback(new Error('请输入第' + (i + 1) + '行数量'))
          }
          if (detail[i].price === '') {
            callback(new Error('请输入第' + (i + 1) + '行单价'))
          }
        }
      }
      callback()
    }

    const validateCompleteDate = (rule, completeDate, callback) => {
      if (this.eaParams.is_completed === '是') {
        if (completeDate === '' || completeDate === null) {
          callback(new Error('请选择完工日期'))
        }
      }
      callback()
    }
    return {
      chooseDate: '',
      chooseLaLaDate: '',
      currentIndex: -1,
      addDiDiDialog: false,
      addLaLaDialog: false,
      storeList: [],
      car_date_list: [],
      car_la_la_date_list: [],
      uploadLoading: false,
      qyts: [],
      initData: {},
      pageTypes: ['add', 'update', 'detail'],
      pageType: 'detail',
      loading: false,
      receiptsLoading: false,
      invoicesLoading: false,
      workers: [],
      cityList: [],
      brandsList: [],
      imageList: [],
      markets: [],
      searchData: '',
      projects: [],
      companies: [],
      personList: [],
      defaultDetailParams: {
        index: 0,
        detail: '',
        num: '',
        unit: '项',
        price: '',
        total_price: '0.00',
        remark: '',
        reim_type: 'material_fee',
      },
      eaParams: {
        company_id: '',
        city_id: '',
        reim_detail_list: [],
        brand_id: '',
        shop_id: '',
        is_finished: 1,
        market_id: '',
        type: 0,
        typeCn: '',
        details: [],
        is_report: false,
        remark: '',
        images: {
          sign: [],
          invoice: []
        },
        is_advance: '1',
        location: '',
        total_price: '',
        order_id: null,
        maintenance_id: null,
        id: null,
        picture_images: [],
        pre_quote_status: 0
      },
      eaRules: {
        completed_at: [{ required: true, trigger: 'blur', validator: validateCompleteDate }],
        brand_id: [{ required: true, message: '必选项！', trigger: 'blur' }],
        city_id: [{ required: true, message: '必选项！', trigger: 'blur' }],
        market_id: [{ required: true, message: '必选项！', trigger: 'blur' }],
        store_id: [{ required: true, message: '必选项！', trigger: 'blur' }],
        company_id: [{ required: true, message: '必选项！', trigger: 'blur' }],
        ma_remark: [{ required: true, message: '必选项！', trigger: 'blur' }],
        ma_type_cn: [{ required: true, message: '必选项！', trigger: 'blur' }],
        ma_cate_id: [{ required: true, message: '必选项！', trigger: 'blur' }],
        is_advance: [{ required: true, message: '必选项！', trigger: 'blur' }],
        reim_detail_list: [{ required: true, trigger: 'change', validator: validateDetail }],
        total_price: [{ required: true, message: '必选项！', trigger: 'blur' }],
      },
      hasReported: false,
      previewDialog: false,
      feeType: [
        {
          k: '人工费',
          v: 'labor_cost'
        },
        {
          k: '材料费',
          v: 'material_fee'
        },
        {
          k: '交通费',
          v: 'transportation_fee',
        },
        {
          k: '住宿费',
          v: 'accommodation_fee',
        },
        {
          k: '差补',
          v: 'allowance',
        }
      ],
      previewUrl: '',
      workerList: [],
      restaurants: [],
      input_content: '',
      qy_di_di_reim_type_cn: '企业滴滴',
      qy_di_di_reim_type: 'qy_di_di',
      qy_huo_la_la_reim_type_cn: '企业货拉拉',
      qy_huo_la_la_reim_type: 'qy_huo_la_la',
      user_id: 0,
    }
  },
  mounted() {
    this.restaurants = this.loadAll();
  },
  created() {
    if (this.pageType === 'add') {
      document.title = '新建报销单'
    } else if (this.pageType === 'update') {
      document.title = '修改申请'
    } else {
      document.title = '报销单详情'
    }
    this.user_id = localStorage.getItem('id');
    this.pageType = this.detailPageType
    this.initOptions()
    this.initEaParams()
    this.initQyts()
    this.initWorkers()
  },
  methods: {
    addDiDiTime() {
      this.addDiDiDialog = true
      this.chooseDate = ''
      this.currentIndex = -1
    },
    addLaLaTime() {
      this.addLaLaDialog = true
      this.chooseLaLaDate = ''
      this.currentIndex = -1
    },
    deleteSelectDate(index) {
      this.car_date_list.splice(index, 1)
    },
    deleteSelectLaLaDate(index) {
      this.car_la_la_date_list.splice(index, 1)
    },
    changeSelectDate(item, index) {
      this.currentIndex = index
      this.addDiDiDialog = true
      this.chooseDate = item
    },
    changeSelectLaLaDate(item, index) {
      this.currentIndex = index
      this.addLaLaDialog = true
      this.chooseLaLaDate = item
    },
    selectDiDiDate(value) {
      this.addDiDiDialog = false
      if (value === '') {
        return false
      }
      if (this.currentIndex >= 0) {
        this.car_date_list[this.currentIndex] = value
        this.$set(this.car_date_list, this.currentIndex, this.car_date_list[this.currentIndex])
      } else {
        this.car_date_list.push(value)
      }

      this.$forceUpdate()
    },
    selectLaLaDate(value) {
      this.addLaLaDialog = false
      if (value === '') {
        return false
      }
      if (this.currentIndex >= 0) {
        this.car_la_la_date_list[this.currentIndex] = value
        this.$set(this.car_la_la_date_list, this.currentIndex, this.car_la_la_date_list[this.currentIndex])
      } else {
        this.car_la_la_date_list.push(value)
      }
      console.log('car....la....la....date....list...', this.car_la_la_date_list)
      this.$forceUpdate()
    },
    updateUser(val, index) {
      if (val > 0) {
        this.eaParams.reim_detail_list[index - 1].reim_type = 'labor_cost'
      } else {
        this.eaParams.reim_detail_list[index - 1].reim_type = 'material_fee'
      }
      this.$forceUpdate()
    },
    onReimTypeChange(row) {
      // 当费用类型为人工费时，单位固定为"人"
      if (row.reim_type === 'labor_cost') {
        row.unit = '人'
      }
      this.$forceUpdate()
    },
    updateChange() {
      this.$forceUpdate()
    },
    explain() {
      if (this.input_content.length <= 0) {
        return false;
      }
      parseAddress({address: this.input_content}).then((res) => {
        console.log('res........', res)
        if (res.data.data) {
          if (res.data.data.brand_id) {
            this.eaParams.brand_id = res.data.data.brand_id
          } else {
            this.eaParams.brand_id = ''
          }
          if (res.data.data.city_id) {
            this.eaParams.city_id = res.data.data.city_id
            this.initMarkets(res.data.data.city_id)
          } else {
            this.eaParams.city_id = ''
            this.markets = []
          }
          if (res.data.data.market_id) {
            this.eaParams.market_id = res.data.data.market_id
          } else {
            this.eaParams.market_id = ''
          }
          if (res.data.data.shop_id) {
            this.eaParams.store_id = res.data.data.shop_id
            this.searchStore()
          } else {
            this.eaParams.store_id = ''
          }
        }
      })
    },
    querySearch(queryString, cb) {
      let restaurants = this.restaurants;
      let results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
      };
    },
    loadAll() {
      return [
        { "value": "人工费", },
        { "value": "交通费", },
      ];
    },
    handleSelect(item) {
      console.log(item);
    },
    initWorkers() {
      getCooperateWorkerList({}).then((res) => {
        if (res.data.data) {
          this.workerList = res.data.data
        }
      })
    },
    changeStore() {
      this.$forceUpdate()
    },
    initQyts() {
      qyts().then((res) => {
        if (res.data.data) {
          this.qyts = res.data.data
        }
      })
    },
    changeRepairType() {
      this.eaParams.ma_cate_id = ''
      this.initProjects()
    },
    async initOptions() {
      await this.initCity()
      await this.initBrand()
      this.initProjects()
      this.initCompanies()
    },
    async syncData() {
      this.eaParams.store_id = ''
      this.eaParams.market_id = ''
      await this.initMarkets(this.eaParams.city_id)
      this.searchStore()
    },
    syncShops() {
      this.searchStore()
    },
    initMarkets(cityId) {
      getMarketList({city_id: cityId}).then((res) => {
        if (res.data.data) {
          this.markets = res.data.data
        }
      })
    },
    initCompanies() {
      getCompanyList().then((res) => {
        if (res.data.data) {
          this.companies = res.data.data
        }
      })
    },
    async initCity() {
      await getCityList().then((res) => {
        if (res.data.data) {
          this.cityList = res.data.data
        }
      })
    },
    remoteMethod(query) {
      console.log('query.....', query)
      searchWorkers({search_str: query}).then(res => {
        console.log('res.....', res)
        this.personList = res.data.data
      })
    },
    async initBrand() {
      await getBrandList().then((res) => {
        if (res.data.data) {
          this.brandsList = res.data.data
        }
      })
    },
    searchStore() {
      getShopList({brand_id: this.eaParams.brand_id, city_id: this.eaParams.city_id, market_id: this.eaParams.market_id}).then((res) => {
        if (res.data.data && res.data.data.length > 0) {
          this.storeList = res.data.data
        } else {
          let store_name = ''
          for (const item in this.cityList) {
            if (this.cityList[item].id == this.eaParams.city_id) {
              store_name = this.cityList[item].city_cn
            }

          }
          for (const item in this.markets) {
            if (this.markets[item].id == this.eaParams.market_id) {
              store_name += this.markets[item].market_cn
            }
          }
          this.storeList = []
          this.storeList[0] = { id: -1, city_id: this.eaParams.city_id, brand_id: this.eaParams.brand_id, market_id: this.eaParams.market_id, name_cn: store_name }
          this.storeList[1] = { id: -2, city_id: this.eaParams.city_id, brand_id: this.eaParams.brand_id, market_id: this.eaParams.market_id, name_cn: store_name + '男装' }
          this.storeList[2] = { id: -3, city_id: this.eaParams.city_id, brand_id: this.eaParams.brand_id, market_id: this.eaParams.market_id, name_cn: store_name + '女装' }
          this.storeList[3] = { id: -4, city_id: this.eaParams.city_id, brand_id: this.eaParams.brand_id, market_id: this.eaParams.market_id, name_cn: store_name + '童装' }
          this.storeList[4] = { id: -5, city_id: this.eaParams.city_id, brand_id: this.eaParams.brand_id, market_id: this.eaParams.market_id, name_cn: store_name + '鞋店' }
        }
      })
    },
    initProjects() {
      getCategories({p_type: this.eaParams.ma_type_cn === '紧急维修' ? 'non_fix' : 'fix'}).then((res) => {
        if (res.data.data) {
          this.projects = res.data.data
        }
      })
    },
    initEaParams() {
        if (this.preQuoteStatus) {
          this.eaParams.pre_quote_status = this.preQuoteStatus
        } else {
          this.eaParams.pre_quote_status = 0
        }
        this.eaParams.bill_images = []
        this.eaParams.sign_images = []
        this.eaParams.reim_detail_list = [{
          index: 0,
          detail: '企业滴滴',
          num: 0,
          unit: '项',
          price: 0,
          total_price: '0.00',
          remark: '',
          reim_type: this.qy_di_di_reim_type,
        }, {
          index: 0,
          detail: '企业货拉拉',
          num: 0,
          unit: '项',
          price: 0,
          total_price: '0.00',
          remark: '',
          reim_type: this.qy_huo_la_la_reim_type,
        }]
        if (parseInt(this.preQuoteStatus) == 1 || this.subordinateWorker) {
          this.eaParams.is_report = 0
          this.eaParams.is_advance = 0
          this.eaParams.is_completed = 0
        }
    },
    addDetailParam() {
      if (typeof this.eaParams.reim_detail_list === 'undefined') {
        this.eaParams.reim_detail_list = []
      }
      this.defaultDetailParams.index = this.eaParams.reim_detail_list.length + 1
      this.eaParams.reim_detail_list.splice(this.defaultDetailParams.index + 1, 0, JSON.parse(JSON.stringify(this.defaultDetailParams)))
      this.$forceUpdate()
    },
    delDetailParam(row) {
      for (let i = 0; i < this.eaParams.reim_detail_list.length; i++) {
        if (this.eaParams.reim_detail_list[i] === row) {
          this.eaParams.reim_detail_list.splice(i, 1)
        }
      }
      this.resetSubtotal()
    },
    onDetailChange(type, row) {
      if (type === 'num') {
        row.num = row.num.match(/(^\d*)(\.?\d{0,2})/g)[0]
      }
      if (type === 'price') {
        row.price = row.price.match(/(^\d*)(\.?\d{0,2})/g)[0]
      }
      row.total_price = (row.price * row.num).toFixed(2)
      this.resetSubtotal()
    },
    resetSubtotal() {
      this.eaParams.total_price = 0
      for (let data of this.eaParams.reim_detail_list) {
        this.eaParams.total_price += parseFloat(data.total_price)
      }
      this.eaParams.total_price = this.eaParams.total_price.toFixed(2)
      this.$forceUpdate()
    },
    handleReceiptsRemove(file, fileList) {
      this.eaParams.sign_images = fileList
    },
    async receiptsUpload(file) {
      console.log('receipt....', file)
      await this.uploadImg(file.file, 'sign')
    },
    onReceiptsChange(response, file, fileList) {
      if (response.status === 'ready') {
        this.receiptsLoading = true
      }
    },
    handleInvoicesRemove(file, fileList) {
      this.eaParams.bill_images = fileList
    },
    invoicesUpload(file) {
      this.uploadImg(file.file, 'bill')
    },
    picturesUpload(file) {
      this.uploadImg(file.file, 'pictures')
    },
    handlePicturesRemove(file, fileList) {
      this.eaParams.picture_images = fileList
    },
    async uploadImg (file, index) {
      this.uploadLoading = true
      let fileSuffix = ''
      if (file.type === 'image/jpeg') {
        fileSuffix = 'jpeg'
      }
      if (file.type === 'image/png') {
        fileSuffix = 'png'
      }
      if (file.type === 'image/jpg') {
        fileSuffix = 'jpg'
      }
      await getOssToken({ file_suffix: fileSuffix }).then((res) => {
        if (res.data.data) {
          const ossData = res.data.data
          const client = new OSS({
            region: 'oss-' + ossData.region_id,
            accessKeySecret: ossData.access_secret,
            accessKeyId: ossData.access_id,
            stsToken: ossData.secret_token,
            bucket: ossData.bucket
          })
          client.put(ossData.file_name, file).then((result) => {
            if (result && result.url) {
              getFileRealPath({file_id: ossData.file_id}).then((res) => {
                if (res.data.data && res.data.data.file_url_original) {
                  const data = {
                    id: ossData.file_id,
                    name: ossData.file_name,
                    url: res.data.data.file_url_original.replace('http:', 'https:')
                  }
                  if (index === 'sign') {
                    if (typeof this.eaParams.sign_images === 'undefined') {
                      this.eaParams.sign_images = []
                    }
                    this.eaParams.sign_images.push(data)
                  }
                  if (index === 'bill') {
                    if (typeof this.eaParams.bill_images === 'undefined') {
                      this.eaParams.bill_images = []
                    }
                    this.eaParams.bill_images.push(data)
                  }
                  if (index === 'pictures') {
                    if (typeof this.eaParams.picture_images === 'undefined') {
                      this.eaParams.picture_images = []
                    }
                    this.eaParams.picture_images.push(data)
                  }
                  this.uploadLoading = false
                  this.$forceUpdate()
                }
              })

            }
          })
        }
      })
    },
    onInvoicesChange(response, file, fileList) {
      if (response.status === 'ready') {
        this.invoicesLoading = true
      }
    },
    handlePreview(file) {
      this.previewUrl = file.url
      this.previewDialog = true
    },
    beforeImgUpload(file) {
      if (file.type !== 'image/jpeg' && file.type !== 'image/png' && file.type !== 'image/jpg') {
        this.$message.error('请上传图片！')
        return false
      }
      return true
    },
    apply(row) {
      if (this.eaParams.is_report !== 1 && this.preQuoteStatus != 1) {
        this.$message.error('请确认已在群里报备再提交！')
        return
      }
      this.loading = true
      applyExpenseAccount({ id: row.id }).then((res) => {
        if (res.data.code > 0) {
          this.$message.error(res.data.msg)
        } else {
          this.$message.success('申请成功!')
          row.ea_state = 2
          row.state_cn = '待审核'
        }
        this.loading = false
      }).catch((e) => {
        this.loading = false
      })
    },
    cancelApply(row) {
      this.loading = true
      cancelApplyExpenseAccount({ id: row.id }).then((res) => {
        if (res.data.code > 0) {
          this.$message.error(res.data.msg)
        } else {
          this.$message.success('撤销申请成功!')
          row.ea_state = 1
          row.state_cn = '草稿'
          this.hasReported = false
        }
        this.loading = false
      }).catch((e) => {
        this.loading = false
      })
    },
    deleteDraft(row) {
      this.$confirm('删除后无法恢复，确认删除吗？', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true
        deleteDraftExpenseAccount({ id: row.id }).then((res) => {
          if (res.data.code > 0) {
            this.$message.error(res.data.msg)
          } else {
            this.$message.success('删除草稿成功!')
            this.closeDialog()
          }
          this.loading = false
        }).catch((e) => {
          this.loading = false
        })
      })
    },
    updateEa() {
      this.addEa(1)
    },
    async addEa(addType) {
      if (this.loading) {
        return false
      }
      if (addType !== 'tmp_save' && !this.eaParams.is_report && this.eaParams.pre_quote_status !== 1) {
        this.$message.error('请确认已在群里报备再提交！')
        return
      }
      if (this.uploadLoading) {
        this.$message.error('图片上传中请耐心等待')
        return
      }
      if (this.eaParams.store_id < 0) {
        let store_name_cn = ''
        for (const item in this.storeList) {
          if (this.eaParams.store_id == this.storeList[item].id) {
            store_name_cn = this.storeList[item].name_cn
            break
          }
        }

        const store_info = {
          "store_name_cn": store_name_cn,
          "brand_id": this.eaParams.brand_id,
          "city_id": this.eaParams.city_id,
          "market_id": this.eaParams.market_id
        }
        await addStore(store_info).then((res) => {
          if (res.data.data) {
            this.eaParams.store_id = res.data.data
          }
        })
      }

      const fileIdsArr = []
      for (const i in this.eaParams.picture_images) {
        if (typeof this.eaParams.picture_images[i].id !== 'undefined' && this.eaParams.picture_images[i].id !== 0 && this.eaParams.picture_images[i].id !== '') {
          fileIdsArr.push(this.eaParams.picture_images[i].id)
        }
      }
      const bill_ids_arr = []
      for (const i in this.eaParams.bill_images) {
        if (typeof this.eaParams.bill_images[i].id !== 'undefined' && this.eaParams.bill_images[i].id !== 0 && this.eaParams.bill_images[i].id !== '') {
          bill_ids_arr.push(this.eaParams.bill_images[i].id)
        }
      }
      this.eaParams.ma_type = this.eaParams.ma_type_cn === '紧急维修' ? 'urgent' : 'not_urgent'
      this.eaParams.bill_ids = bill_ids_arr.join(',')
      const sign_ids_arr = []
      for (const i in this.eaParams.sign_images) {
        if (typeof this.eaParams.sign_images[i].id !== 'undefined' && this.eaParams.sign_images[i].id !== 0 && this.eaParams.sign_images[i].id !== '') {
          sign_ids_arr.push(this.eaParams.sign_images[i].id)
        }
      }
      this.eaParams.sign_ids = sign_ids_arr.join(',')
      this.eaParams.ma_item_list = [
        {
          ma_cate_id: this.eaParams.ma_cate_id,
          prob_desc: this.eaParams.ma_remark,
          location: this.eaParams.location,
          file_ids: fileIdsArr.join(','),
          appo_task_list: [{
            ma_end_at: '',
            submit_remark: '',
            ma_start_at: '',
            worker_ids: '' // this.eaParams.workers.join(',')
          }]
        }
      ]

      if (typeof this.eaParams.reim_detail_list === 'undefined' || this.eaParams.reim_detail_list.length <= 0) {
        this.$message.error('请填写明细')
        return false
      }

      if (this.eaParams.reim_detail_list[0].detail === '企业滴滴' && this.car_date_list.length > 0) {
        this.eaParams.reim_detail_list[0].remark = this.car_date_list.join(',')
      }

      if (this.eaParams.reim_detail_list[1].detail === '企业货拉拉' && this.car_la_la_date_list.length > 0) {
        this.eaParams.reim_detail_list[1].remark = this.car_la_la_date_list.join(',')
      }

      if (this.eaParams.is_completed == 1 && (typeof this.eaParams.completed_at === 'undefined' || !this.eaParams.completed_at || this.eaParams.completed_at.length <= 0)) {
        this.$message.error('请填写完工时间')
        return false
      }

      this.eaParams.reim_status = addType
      this.$refs.eaParams.validate(async valid => {
        if (valid) {
          this.loading = true
          await createOrderAndReim(this.eaParams).then((res) => {
            if (res.data.code > 0) {
              this.loading = false
              this.$message.error(res.data.msg)
            } else {
              this.loading =false
              this.$message.success('创建成功!')
              this.closeDialog()
              this.pageType = 'detail'
            }
          })
        } else {
          this.loading = false
          console.log('error submit!!')
          return false
        }
      })
    },
    addToCopy(params) {
      let title = params.city + params.market
      this.markets.forEach(item => {
        if (item.id === params.market_id) {
          title += item.market
        }
      })
      for (let i = 0; i < this.initData.brands.length; i++) {
        if (this.initData.brands[i].id === params.brand_id) {
          title += this.initData.brands[i].brand_en
        }
      }
      title += ' ' + params.title

      let num = 1
      for (let i = 0; i < params.details.length; i++) {
        const item = params.details[i]
        const desc = '\r' + num + '. ' + item.description + ' ' + item.qty + '*' + item.unit_price + '  ' + item.subtotal + '元'
        title += desc
        num++
      }
      title += '\r' + '合计：' + params.subtotal + '元'
      const copyMsg = title
      this.$copyText(copyMsg).then(res => {
        this.$message.success({ message: '提交内容已复制到剪切板' })
      })
    },
    onIsCompletedChange() {
      if (this.eaParams.is_completed === 0) {
        this.eaParams.complete_date = ''
      }
      this.$forceUpdate()
      console.log(this.eaParams)
    }
  }
}
</script>

<style >
.account-container {
  width: 94%;
  margin: 10px auto;
}
* {
  padding: 0;
  margin: 0;
}
.form-item-width {
  width: 240px;
}
.el-form--label-top .el-form-item__label {
  padding: 0;
}
.select-brand .el-scrollbar .el-select-dropdown__wrap {
  /*max-height: 100%;*/
}
.input-center > .el-input__inner {
  text-align: center;
  padding: 0;
}
.input-right > .el-input__inner {
  text-align: right;
  padding-left: 0;
}
.el-form-item__label {
  float: left !important;
  width: 120px;
}
.el-form-item__content {
  float: left;
}
.el-input__inner {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/order/components/order-reimbursement.vue